var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaxChatsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1307.71 678.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2, .cls-3 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        font-size: 252px;\r\n      }\r\n\r\n      .cls-2, .cls-3 {\r\n        font-family: Calibri-Bold, Calibri;\r\n        font-weight: 700;\r\n      }\r\n\r\n      .cls-4 {\r\n        letter-spacing: 0em;\r\n      }\r\n\r\n      .cls-3 {\r\n        font-size: 192px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(235.57 555.42)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 220.25,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 342.32,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(696.51 555.42)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Ch"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 204.66,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 297.66,
    y: 0
  }, "ts")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M845.95,309.11c-9.52,12.79-20.91,23.83-33.64,32.97-.86.62-1.71,1.2-2.57,1.8-.04.02-.07.06-.11.08-16.78,11.53-35.8,19.81-55.99,24.44-.13.04-.26.08-.39.09-27.6,6.29-57.41,5.73-86.66-2.7-.13-.04-.26-.07-.39-.11-.83-.24-1.63-.49-2.44-.73-62.31-19.17-112.27-75.3-117.77-148.54-.66-8.56-.69-17.33-.07-26.32,1.05-15.34,4.43-30.49,9.86-44.98.41-1.15.86-2.29,1.31-3.44.11-.3.24-.62.36-.92.43-1.13.9-2.25,1.37-3.36.54-1.26,1.09-2.5,1.63-3.74.45-.98.9-1.95,1.37-2.93.62-1.28,1.24-2.55,1.9-3.81.02-.04.04-.07.06-.11.62-1.22,1.28-2.44,1.93-3.64.02-.02.02-.04.02-.06.34-.58.66-1.18.98-1.76.32-.6.66-1.2,1.01-1.8,2.57-4.47,5.35-8.84,8.34-13.09.73-1.07,1.5-2.12,2.27-3.15,1.52-2.1,3.12-4.15,4.75-6.18.75-.94,1.5-1.86,2.29-2.78.09-.11.19-.24.3-.36.79-.94,1.61-1.88,2.44-2.82,19.81-22.38,45.64-39.75,75.53-48.49-4.45,4.84-8.2,8.75-11.72,12.82-21.95,25.5-33.32,55.1-35.62,88.63-1.97,28.74,4.13,58.33,17.69,83.53,3.4,12,9.33,23.28,17.2,32.93,3.21,3.49,6.66,6.78,10.36,9.78-.26,2.46-.58,4.92-.88,7.4-.15,7.21-3.89,14.91-.69,21.83l-.43.38c2.65,1.8,6.03,3.89,9.26,2.08,7.62-4.71,14.1-11.1,21.63-15.98l1.54.38c9.42,2.95,19.26,4,29.04,3.55,6.08.11,12.05-.64,17.8-2.33,1.2-.26,2.4-.54,3.6-.84,1.8-.45,3.59-1.22,5.31-1.88,14.46-5.58,26.4-14.55,35.05-26.27,21.4,17.08,42.32,33.76,63.2,50.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M846.72,97.45c-22.04,17.69-43.41,34.81-64.7,51.87-12.2-13.93-30.06-22.87-48.95-26.1-10.61-1.82-21.4-1.63-31.84.43-13.39,2.25-26.19,7.92-37.19,16.78-.17.13-.34.24-.49.39-11.45,9.37-20.91,22.23-26.96,38.34-.24-.73-.49-1.45-.69-2.18-2.67-9.24-2.1-18.46-1.67-27.52,1.41-28.91,10.44-55.25,30.06-76.86,28.22-31.07,63.25-41.06,103.62-29.7,5.01,1.41,9.88,3.08,14.61,4.98,23.17,9.26,42.9,24.13,59.63,43.35.32.36.62.73.92,1.13.04.04.08.08.11.13,1,1.31,2.03,2.87,3.55,4.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M755.81,209.1c-1.39,7.15-11.38,10.65-16.69,5.44-6.1-4.69-4.09-15.47,3.29-17.67,7.28-2.93,15.71,4.69,13.41,12.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M727.95,208.95c-1.35,7.47-11.62,10.74-17.03,5.37-5.65-4.73-3.79-14.89,3.19-17.29,7.28-3.25,16.01,4.22,13.84,11.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M700.07,208.76c-1.26,7.75-12.02,11.06-17.37,5.28-5.54-5.05-3.1-15.34,4.17-17.24,7.15-2.61,15.09,4.6,13.2,11.96Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaxChatsLogo);
export default __webpack_public_path__ + "static/media/MaxChatsLogo.a9e3f0b9c358af79f110cdc1df671ff9.svg";
export { ForwardRef as ReactComponent };